import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import { ApiHelper } from '../helpers/ApiHelper';
import { Helper } from '../helpers/Helper';
import { UiHelper } from '../helpers/UiHelper';

import { AppStyles } from '../../styles/AppTheme';
import { UploadHelper } from '../helpers/UploadHelper';

export class DocumentUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      fetchState: ApiHelper.State.READY
    };
  }

  componentDidMount() {
  }

  render() {
    return (
      <div className={css(Styles.container)}>
        <input
          className={css(Styles.fileInput)}
          onChange={this.onFileChange.bind(this)}
          type='file'
          accept={this.props.uploadAccept || 'application/pdf'} />
        <div className={css(Styles.buttonContainer)}>
          <Button
            className={css(Styles.button)}
            size='small'
            onClick={this.onUpload.bind(this)}>
            {'Upload'.toUpperCase()}
          </Button>
          {this.renderMessage()}
        </div>
      </div>
    )
  }

  renderMessage() {
    let messageClass = css(Styles.textUpload, Styles.text)
    if(this.state.fetchState === ApiHelper.State.ERROR) {
      messageClass = css(Styles.textError, Styles.text)
    } else if(this.state.fetchState === ApiHelper.State.READY) {
      messageClass = css(Styles.textSuccess, Styles.text)
    }
    return  (<p className={messageClass}>{this.state.message}</p>)
  }

  onUpload() {
    if(!this.state.file) {
      return this.onError(Helper.getString('fileChoose'))
    }
    this.setState(
      {
        message: '',
        fetchState: ApiHelper.State.READY
      }
    )

    let ext = null;
    if (this.state.file && this.state.file.name) {
      const userInputFilename = this.state.file.name;
      ext = userInputFilename.split('.').pop()
    }

    const options = {
      type: this.props.uploadType || 'media',
      ext: ext || this.props.uploadExt || 'pdf'
    }
    this.onUploadProgress()
    UploadHelper.fetchUploadUrl({}, options, (err, signedUploadInfo) => {
      if (err) {
        return this.onError(err)
      }
      console.log('fetchUploadUrl:', err, signedUploadInfo)
      const uploadOptions = {
        pickerResult: this.state.file,
        signedUploadInfo: signedUploadInfo,
        onEvent: (type, percent) => {
          console.log('progress:', type, percent)
          if (type === 'progress') {
            return this.onUploadProgress(percent)
          } else if (type === 'load') {
            return this.onUploadComplete(signedUploadInfo)
          } else if (type === 'error') {
            return this.onError(Helper.getString('fileUploadErr'))
          }
        }
      }
      UploadHelper.uploadFormDataWithProgress(uploadOptions)
    })
  }

  onFileChange(e) {
    const file = e.target.files[0]
    // TODO: validate Extension & Size
    const reader = new FileReader();
    reader.onload = (e) => {
      this.setState(
        {
          file: file,
          dataURL: e.target.result,
          message: '',
          fetchState: ApiHelper.State.READY
        }
      )
    }
    reader.readAsDataURL(file)
  }

  onUploadProgress(percent) {
    console.log('onUploadProgress:', percent);
    let message = 'Uploading'
    if (percent) {
      message += ': ' + percent + ' %'
    } else {
      message += '...'
    }
    this.setState({
      message: message,
      fetchState: ApiHelper.State.LOADING
    })
  }

  onUploadComplete(signedUploadInfo) {
    this.setState({
      message: Helper.getString('fileUploadSuccess'),
      fetchState: ApiHelper.State.READY
    })
    if (this.props.onUploadSuccess) {
      this.props.onUploadSuccess(this.props.uploadId, signedUploadInfo)
    }
  }

  onError(err) {
    console.log('err:', err);
    this.setState({
      message: Helper.getErrorMsg(err),
      fetchState: ApiHelper.State.ERROR
    })
  }
}

const Styles = StyleSheet.create({
  container: {
    backgroundColor: 'whitesmoke',
    padding: 5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: 5
  },
  fileInput: {
    width: '100%'
  },
  button: {
    backgroundColor: 'black',
    color: 'white',
    maxWidth: 100,
    minHeight: 24,
    textAlign: 'center',
    fontSize: 10,
    marginRight: 10
  },
  text: {
    marginTop: 3,
    marginBottom: 3,
    fontSize: 10
  },
  textUpload: {
    color: 'black',
  },
  textError: {
    color: 'red',
  },
  textSuccess: {
    color: 'green',
  }
})


// WEBPACK FOOTER //
// ./src/common/components/DocumentUploader.js